import { inject, observer } from 'mobx-react';
import { ReactComponent as CheckRight } from '../../svg/chevron-right.svg'
import React from 'react'
import Loader from '../Buttons/Loader';

@inject('workAreaStore', 'mockupStore') @observer
class MockupSidebar extends React.Component {

  toggleMockup(){
    this.props.mockupStore.toggleSidebar()
  }

  componentDidMount(){
    if(this.props.workAreaStore.mockupBase && !this.props.mockupStore.mockupLoaded){
      this.props.mockupStore.updateMockup(true)
    }
  }

  update(){
    this.props.mockupStore.updateMockup()
  }

  routeToEditor(){
    this.props.mockupStore.routeToMockupEditor()
  }

  render(){
    const { sidebarOpen, mockupPreview, mockupLoaded, saveLoading, mockupLoading } = this.props.mockupStore
    const { workAreaStore } = this.props
    const { mockupMeta } = workAreaStore
    if(!workAreaStore.mockupBase){
      return <div />
    }
    return (
        <div className='mockup-wrapper'>
          {
            sidebarOpen ? (
            <div 
              className='mockup'
              onClick={() => {
                workAreaStore.toggleAlign(false)
                workAreaStore.toggleShift(false)
              }}
            >
                <div className='mockup__body'>
                  {
                    mockupLoaded ? (
                      <>
                      <h5 className='mockup__body__title'>
                        Mockup preview
                      </h5>
                      <span className='gray mockup__body__subtitle'>
                        {mockupMeta ? mockupMeta.description : ''}
                      </span>
                      <div className='mockup__body__image'>
                        <img src={mockupPreview} />
                      </div>
                      <div className='mockup__body__buttons'>
                        {
                          mockupLoading ? (
                            <div className='loader-center'>
                              <Loader className='small btn-loader' />
                            </div>
                          )
                          :
                          (
                            <button
                              onClick={() => this.update()}
                              className='btn btn-primary'>
                              Update preview
                            </button>
                          )
                        }
                        {
                          saveLoading ? (
                            <div className='loader-center'>
                              <Loader className='small btn-loader' />
                            </div>
                          )
                          :
                          (
                            <button
                              onClick={() => this.routeToEditor()}
                              className='btn btn-secondary'>
                              To mockup editor
                            </button>
                          )
                        }
                      </div>
                      <div className='mockup__body__meta'>
                        {
                          mockupMeta ? (
                            <div className='mockup__body__meta__wrapper'>
                            <span className='gray mockup-meta-data'>Editing layer: <b>{mockupMeta.layerLabel}</b></span>
                              <span className='gray mockup-meta-data'>Layer resolution: <b>{mockupMeta.resolution}</b></span>
                            </div>
                          )
                          :
                          undefined
                        }
                      </div>
                      </>
                    )
                    :
                    (
                      <div className='mockup__body__loading'>
                        <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
                      </div>
                    )
                  }
                </div>
              </div>
            )
            :
            undefined
          }
          <div 
            className='mockup-toggle' 
            style={{
              left: sidebarOpen ? '-320px' : '-20px',
              transform: 'rotate(180deg)'
            }} 
            onClick={this.toggleMockup.bind(this)}>
            {
              <CheckRight style={{ transform: sidebarOpen ? `rotate(180deg)` : 'none' }} />
            }
          </div>
      </div>
    )
  }

}

export default MockupSidebar